// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1FRdV","head":"Table_head__WeZ8x","col":"Table_col__2LFUM"};